import { createSlice } from '@reduxjs/toolkit';

// Initial State
type SliceState = {
  // true = fully expanded sidebar, false = collapsed icon rail (md+ screens)
  isOpen: boolean;
  // true = overlay drawer is showing (below md); independent from isOpen so
  // resizing the window never leaks one mode's state into the other
  isMobileOpen: boolean;
};

const initialState: SliceState = {
  isOpen: false,
  isMobileOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.isOpen = !state.isOpen;
    },
    toggleMobileSidebar(state) {
      state.isMobileOpen = !state.isMobileOpen;
    },
    closeMobileSidebar(state) {
      state.isMobileOpen = false;
    },
  },
});

export const { toggleSidebar, toggleMobileSidebar, closeMobileSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
